/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Link } from '@coursera/event-pulse/react';

import TrackedDiv from 'bundles/page/components/TrackedDiv';
import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';

type Props = {
  href: string;
  text: string;
};

const styles = {
  trackedDiv: css`
    display: inline-block;
  `,
};

const KeyInformationSyllabusLink = ({ text, href }: Props) => {
  const eventingProductData = useEventingProductData();

  return (
    <TrackedDiv trackingName="kim_view_syllabus" css={styles.trackedDiv}>
      <Link
        variant="quiet"
        href={href}
        typographyVariant="subtitleMedium"
        trackingData={{
          button: { name: 'description_page_view_syllabus' },
          pageSection: {
            sectionName: 'kim',
          },
          ...eventingProductData,
        }}
        noViewTracking
      >
        {text}
      </Link>
    </TrackedDiv>
  );
};

export default KeyInformationSyllabusLink;
